import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BlogService } from '../blogs/blog.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'app-blogs-read',
    templateUrl: './blogs-read.component.html',
    styleUrls: ['./blogs-read.component.css'],
    standalone: false
})
export class BlogsReadComponent implements OnInit {

  blog: any = null;
  loading = false;
  safeDescription: SafeHtml = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private blogService: BlogService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const param = params.get('slug'); // renamed from id → slug
      if (!param) return;

      // If numeric → old URL → redirect
      if (/^\d+$/.test(param)) {
        this.loadByIdAndRedirect(param);
      } else {
        this.loadBySlug(param);
      }
    });
  }

  // 🔁 OLD URL SUPPORT: /blogs/12 → /blogs/real-slug
  private loadByIdAndRedirect(id: string) {
    this.loading = true;
    this.blogService.getBlog(id).subscribe(
      res => {
        const blog = res.data || res;
        if (blog && blog.slug) {
          this.router.navigate(['/blogs', blog.slug], { replaceUrl: true });
        } else {
          this.assignBlog(blog);
        }
        this.loading = false;
      },
      () => {
        this.loading = false;
        alert('Blog not found');
      }
    );
  }

  // ✅ NEW: Load by slug
  private loadBySlug(slug: string) {
    this.loading = true;
    this.blogService.getBlogBySlug(slug).subscribe(
      res => {
        const blog = res.data || res;
        this.assignBlog(blog);
        this.loading = false;
      },
      () => {
        this.loading = false;
        alert('Blog not found');
      }
    );
  }

  private assignBlog(blog: any) {
    if (!blog) return;
    this.blog = blog;
    this.safeDescription = blog.description
      ? this.sanitizer.bypassSecurityTrustHtml(blog.description)
      : '';
  }


  
}